var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGradientSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.8688 15.9575C19.3126 12.819 19.0918 8.27833 16.2067 5.39315C13.0825 2.26895 8.01714 2.26895 4.89295 5.39315C1.76876 8.51734 1.76876 13.5827 4.89295 16.7069C7.77813 19.592 12.3188 19.8128 15.4573 17.369C15.4708 17.3843 15.4849 17.3993 15.4996 17.414L19.7422 21.6566C20.1327 22.0471 20.7659 22.0471 21.1564 21.6566C21.5469 21.2661 21.5469 20.6329 21.1564 20.2424L16.9138 15.9998C16.8991 15.9851 16.8841 15.971 16.8688 15.9575ZM14.7924 6.80736C17.1356 9.15051 17.1356 12.9495 14.7924 15.2926C12.4493 17.6358 8.65031 17.6358 6.30716 15.2926C3.96402 12.9495 3.96402 9.15051 6.30716 6.80736C8.65031 4.46422 12.4493 4.46422 14.7924 6.80736Z",
    fill: "url(#paint0_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 2.5498,
    y1: 12.4998,
    x2: 21.4493,
    y2: 12.4998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#84FAB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8FEAFE"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGradientSearch);
export default __webpack_public_path__ + "static/media/gradient-search.9681c737.svg";
export { ForwardRef as ReactComponent };